export const GA4_MEASUREMENT_ID = 'G-QYYF4MVKCZ';

type Ga4EventParams = Record<string, unknown>;
type GtagCommand = 'js' | 'config' | 'event';
type Gtag = (command: GtagCommand, target: string | Date, params?: Ga4EventParams) => void;

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: Gtag;
  }
}

let ga4Initialized = false;
let ga4ScriptRequested = false;

const ensureGtag = () => {
  if (typeof window === 'undefined') return null;

  window.dataLayer = window.dataLayer || [];

  if (!window.gtag) {
    window.gtag = function gtag(command: GtagCommand, target: string | Date, params?: Ga4EventParams) {
      void command;
      void target;
      void params;
      // Google gtag expects queued commands in the native `arguments` shape.
      // eslint-disable-next-line prefer-rest-params
      window.dataLayer?.push(arguments);
    };
  }

  return window.gtag;
};

const loadGa4Script = () => {
  if (typeof window === 'undefined' || ga4ScriptRequested) return;

  ga4ScriptRequested = true;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_MEASUREMENT_ID}`;
  document.head.appendChild(script);
};

export const initGa4 = () => {
  if (typeof window === 'undefined' || ga4Initialized) return;

  const gtag = ensureGtag();
  if (!gtag) return;

  loadGa4Script();

  gtag('js', new Date());
  gtag('config', GA4_MEASUREMENT_ID, {
    send_page_view: false,
  });

  ga4Initialized = true;
};

export const trackGa4Event = (eventName: string, params?: Ga4EventParams) => {
  initGa4();

  const gtag = ensureGtag();
  if (!gtag) return;

  gtag('event', eventName, params);
};
